import React from "react";
import { createPortal } from "react-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "./Button";

interface StripeConnectInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const StripeConnectInfoDialog: React.FC<StripeConnectInfoDialogProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4"
      style={{ backdropFilter: "blur(4px)" }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div 
        className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Stripe Connect Benefits</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-700">
                Registration is very simple: just follow the steps and in a few minutes you&apos;ll be ready to receive payments
              </p>
            </div>
            
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-700">
                Receive your earnings directly into your local bank account (IBAN or account number)
              </p>
            </div>
            
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-700">
                In many countries, you can also get your money instantly on your Visa or Mastercard debit card
              </p>
            </div>
            
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-700">
                Fees are lower compared to traditional bank transfers and PayPal
              </p>
            </div>
          </div>
          
          <div className="mt-6 pt-4 border-t border-gray-200">
            <Button 
              onClick={onClose}
              className="w-full"
            >
              Got it
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StripeConnectInfoDialog;

